import React, { Component } from "react";
import PropTypes from "prop-types";
import { JobService, InvoiceService, InstantPayService } from "@services";
import utils from "@utils";
import { ReactSelect, Tooltip } from "../../../../../components";

import "./InstantPayAudit.scss";

class InstantPayAudit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			jobEventIdIP: "",
			positionIP: "",
			officerIP: "",
			reasons: "",
			loadingReasons: false,
			positions: [],
			loadingPositions: false,
			assignedOfficers: [],
			loadingOfficers: false,
			searchJobTimeout: 0,
			ipAuditBtnEnabled: false,
		};
	}

	changeJobHandler = ev => {
		const { searchJobTimeout } = this.state;
		let jobEventId = "";

		this.setState({
			positionIP: "",
			positions: [],
			officerIP: "",
			assignedOfficers: [],
			ipAuditBtnEnabled: false,
		});

		if (ev && ev.target && ev.target.value !== "") {
			jobEventId = ev.target.value;
		}

		if (searchJobTimeout) {
			clearTimeout(searchJobTimeout);
		}

		this.setState({
			jobEventIdIP: jobEventId,
			searchJobTimeout: setTimeout(() => {
				this.getJobEventPositions();
			}, 1000),
		});
	};

	changePositionHandler = ev => {
		let positionId = "";

		this.setState({
			officerIP: "",
			assignedOfficers: [],
		});

		if (ev && ev.value && ev.value !== "") {
			positionId = ev.value;
		}

		this.setState({
			positionIP: positionId,
		});

		this.getJobEventPersonnelNames(positionId);
	};

	changeAssignedOfficerHandler = ev => {
		let officerId = "";

		if (ev && ev.value && ev.value !== "") {
			officerId = ev.value;
		}

		this.setState({
			officerIP: officerId,
			ipAuditBtnEnabled: officerId && officerId !== "",
		});
	};

	getInstantPayReasons = () => {
		const { jobEventIdIP } = this.state;
		const myCurrentDateTime = `${new Date().toLocaleString()}`;
		const queryParams = {};
		queryParams.requestDateTime = myCurrentDateTime;
		if (jobEventIdIP !== "") {
			InvoiceService.getInstantPayReasonsInvoice(jobEventIdIP, queryParams)
				.then(response => {
					const filteredResponse = response.data;
					this.setState({
						reasons: filteredResponse,
					});
				})
				.catch(() => {
					const { lang } = global;
					utils.notify({
						type: "error",
						message: lang.t("Error loading Instant Pay reasons, Please try again_"),
					});
				});
		}
	};

	getJobEventPositions = () => {
		const { jobEventIdIP } = this.state;

		if (jobEventIdIP !== "") {
			this.setState({
				loadingPositions: true,
			});

			JobService.getJobEventPositions(jobEventIdIP)
				.then(response => {
					const filteredResponse = response.data;
					this.setState({
						positions: this.getPositionsSelectMap(filteredResponse),
						loadingPositions: false,
					});
				})
				.catch(() => {
					this.setState({
						positions: [],
						loadingPositions: false,
					});
				});
		}
	};

	getPositionsSelectMap = positions => {
		if (positions && positions.length > 0) {
			return positions.map(item => ({
				value: item.Id,
				label: item.Title,
			}));
		}

		return [];
	};

	getJobEventPersonnelNames = positionId => {
		if (positionId !== "") {
			this.setState({
				loadingOfficers: true,
				ipAuditBtnEnabled: false,
			});

			JobService.getAssignedOfficersByPositionId(positionId)
				.then(response => {
					const filteredResponse = this.getAssignedOfficerSelectMap(response.data);
					this.setState({
						assignedOfficers: filteredResponse,
						loadingOfficers: false,
					});
				})
				.catch(() => {
					this.setState({
						assignedOfficers: [],
						loadingOfficers: false,
						ipAuditBtnEnabled: false,
					});
				});
		}
	};

	getAssignedOfficerSelectMap = response => {
		let officersSelect = [];

		if (response) {
			const { AssignedOfficers, ExternalOfficers } = response;

			if (AssignedOfficers && AssignedOfficers.length > 0) {
				officersSelect = officersSelect.concat(
					AssignedOfficers.map(item => ({
						value: item.OfficerProfile.Id,
						label: `${item.OfficerProfile.FirstName} ${item.OfficerProfile.LastName}`,
					})),
				);
			}

			if (ExternalOfficers && ExternalOfficers.length > 0) {
				officersSelect = officersSelect.concat(
					ExternalOfficers.map(item => ({
						value: item.Id,
						label: item.OfficerName,
					})),
				);
			}
		}

		return officersSelect;
	};

	getInstantPayAuditData = () => {
		const { positionIP, officerIP } = this.state;

		this.setState({
			reasons: "",
			loadingReasons: false,
			ipAuditBtnEnabled: false,
		});

		if (positionIP !== "" && officerIP !== "") {
			this.setState({
				loadingReasons: true,
			});

			InstantPayService.getInstantPayEligibility(positionIP, officerIP)
				.then(response => {
					const filteredResponse = response.data;
					this.setState({
						reasons: filteredResponse,
						loadingReasons: false,
						ipAuditBtnEnabled: true,
					});
				})
				.catch(() => {
					this.setState({
						reasons: "",
						loadingReasons: false,
						ipAuditBtnEnabled: true,
					});
				});
		}
	};

	getPayTotal = reasons => {
		let amount = 0.0;

		if (reasons.InstantPayEstimate != null && reasons.InstantPayEstimate.Amount) {
			amount = reasons.InstantPayEstimate.Amount;
		}

		if (reasons.InstantPayPayment != null && reasons.InstantPayPayment.Amount) {
			amount = reasons.InstantPayPayment.Amount;
		}

		return <span> {amount}</span>;
	};

	getOfficerPay = reasons => {
		let total = 0.0;

		if (
			reasons.InstantPayEstimate != null &&
			reasons.InstantPayEstimate.Amount &&
			reasons.InstantPayEstimate.Fee
		) {
			total = parseFloat(
				reasons.InstantPayEstimate.Amount + reasons.InstantPayEstimate.Fee,
			).toFixed(2);
		}

		if (
			reasons.InstantPayPayment != null &&
			reasons.InstantPayPayment.Amount &&
			reasons.InstantPayPayment.Fee
		) {
			total = parseFloat(
				reasons.InstantPayPayment.Amount + reasons.InstantPayPayment.Fee,
			).toFixed(2);
		}

		return <span> {total}</span>;
	};

	render() {
		const { lang } = global;
		const {
			jobEventIdIP,
			positionIP,
			officerIP,
			reasons,
			loadingReasons,
			positions,
			loadingPositions,
			assignedOfficers,
			loadingOfficers,
			ipAuditBtnEnabled,
		} = this.state;
		const { user } = this.props;

		const criteriaIconClassMap = {
			0: <i className="rkf line-mark">-</i>,
			1: <i className="rkf rkf-check-mark check-mark" />,
			2: <i className="rkf rkf-cross cross-mark" />,
		};

		return (
			<div
				id="instant-pay-audit"
				className="container"
			>
				<div className="row">
					<div className="col-sm-12">
						<h2>{lang.t("Instant Pay Audit")}</h2>
					</div>
				</div>
				<div className="row">
					<p className="col-sm-12">
						{lang.t(
							"Input the following fields to see if an invoice/timecard is eligible for Instant Pay",
						)}
					</p>
				</div>
				<div className="row">
					<div className="col-sm-3 form-group">
						<label htmlFor="jobid-search-ip">{lang.t("Job ID")}</label>
						<input
							type="tel"
							id="jobid-search-ip"
							name="jobid-search-ip"
							className="form-control"
							onChange={ev => this.changeJobHandler(ev)}
							value={jobEventIdIP}
						/>
					</div>
					<div className="col-sm-3 form-group">
						<label htmlFor="positionIP-search">{lang.t("Position")}</label>
						<input
							type="tel"
							style={{ display: "none" }}
							id="positionIP-search"
							name="positionIP-search"
							className="form-control"
							value={positionIP}
						/>
						<ReactSelect
							name="positionIP-select"
							id="positionIP-select"
							value={positionIP}
							onChange={ev => this.changePositionHandler(ev)}
							options={positions}
							isLoading={loadingPositions}
						/>
					</div>
					<div className="col-sm-3 form-group">
						<label htmlFor="personnel-search">{lang.t("Personnel Name")}</label>
						<input
							type="tel"
							style={{ display: "none" }}
							id="personnel-search"
							name="personnel-search"
							className="form-control"
							value={officerIP}
						/>
						<ReactSelect
							name="personnel-select"
							id="personnel-select"
							value={officerIP}
							onChange={ev => this.changeAssignedOfficerHandler(ev)}
							options={assignedOfficers}
							isLoading={loadingOfficers}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-9 form-group">
						<button
							type="button"
							className="btn btn-primary"
							onClick={this.getInstantPayAuditData}
							disabled={!ipAuditBtnEnabled}
						>
							{lang.t("Audit")}
						</button>
						<Tooltip
							content={lang.t(
								"The audit tool requires all three filters above to be selected to start the audit_",
							)}
						>
							<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
						</Tooltip>
					</div>
				</div>
				<If condition={loadingReasons}>
					<div className="col-xs-12 text-center">
						<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
					</div>
				</If>
				<If condition={reasons != null && reasons !== ""}>
					<div className="row">
						<div className="col-sm-1">
							<p>{new Date().toLocaleDateString()}</p>
						</div>
						<div className="col-sm-11">
							<p>{new Date().toLocaleTimeString()}</p>
						</div>
						<div className="col-sm-3">
							<strong>Job name:</strong>
							<span> {reasons.JobName}</span>
						</div>
						<div className="col-sm-3">
							<strong>Client name:</strong>
							<span> {reasons.ClientName}</span>
						</div>
						<div className="col-sm-3">
							<strong>Job start date:</strong>
							<span>
								{" "}
								{utils.formatDate(
									new Date(`${reasons.JobStartDate}Z`),
									"en-US",
									user.TimeZoneId,
								)}
							</span>
						</div>
						<div className="col-sm-3">
							<strong>Officer pay:</strong>
							<span>{this.getOfficerPay(reasons)}</span>
						</div>
						<div className="col-sm-12">
							<strong>IP take and end total:</strong>
							<span>{this.getPayTotal(reasons)}</span>
						</div>
						<div className="row instant-pay-table">
							<div
								className="col-sm-4 instant-pay-cell"
								style={{ borderRight: "none", borderBottom: "none" }}
							>
								<p className="instant-pay-cell-title">RollKall Criteria </p>
								<div className="cell-content">
									<div className="instant-pay-cell-content row">
										<span className="col-sm-1">
											{
												criteriaIconClassMap[
													reasons.StripeCriteria.DailyLimitMet
												]
											}
										</span>
										<p className="col-sm-11">Daily limit not met</p>
									</div>
									<div className="instant-pay-cell-content row">
										<span className="col-sm-1">
											{
												criteriaIconClassMap[
													reasons.StripeCriteria.FundsAvailable
												]
											}
										</span>
										<p className="col-sm-11">Funds available in Stripe</p>
									</div>
								</div>
							</div>
							<div
								className="col-sm-4 instant-pay-cell"
								style={{ borderRight: "none", borderBottom: "none" }}
							>
								<p className="instant-pay-cell-title">Agency Criteria</p>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.OrgCriteria.InstantPay]}
									</span>
									<p className="col-sm-11">Has IP enabled</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{
											criteriaIconClassMap[
												reasons.OrgCriteria.TransferPaymentToJurisdiction
											]
										}
									</span>
									<p className="col-sm-11">Is 1099</p>
								</div>
							</div>
							<div
								className="col-sm-4 instant-pay-cell"
								style={{ borderBottom: "none" }}
							>
								<p className="instant-pay-cell-title">Client Criteria</p>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.ClientCriteria.InstantPay]}
									</span>
									<p className="col-sm-11">Has IP enabled</p>
								</div>
							</div>
							<div
								className="col-sm-4 instant-pay-cell"
								style={{ borderRight: "none" }}
							>
								<p className="instant-pay-cell-title">Personnel Criteria</p>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.UserCriteria.InstantPay]}
									</span>
									<p className="col-sm-11">Has IP enabled</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.UserCriteria.DisputeRatio]}
									</span>
									<p className="col-sm-11">{"Dispute ratio is <25%"}</p>
								</div>
							</div>
							<div
								className="col-sm-4 instant-pay-cell"
								style={{ borderRight: "none" }}
							>
								<p className="instant-pay-cell-title">Job Criteria</p>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{
											criteriaIconClassMap[
												reasons.JobCriteria.TransferPaymentToJurisdiction
											]
										}
									</span>
									<p className="col-sm-11">Is 1099</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.JobCriteria.ScheduleOnly]}
									</span>
									<p className="col-sm-11">Is Agency or Officer Invoicing</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.JobCriteria.FlexJob]}
									</span>
									<p className="col-sm-11">Is not a flex job</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.JobCriteria.PayCode]}
									</span>
									<p className="col-sm-11">Is not using pay codes</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{
											criteriaIconClassMap[
												reasons.JobCriteria.ExcludeOfficerRate
											]
										}
									</span>
									<p className="col-sm-11">Exclude officer pay</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{
											criteriaIconClassMap[
												reasons.JobCriteria.RequiredWithinTimeFrame
											]
										}
									</span>
									<p className="col-sm-11">
										Within 7 days of job position completion
									</p>
								</div>
							</div>
							<div className="col-sm-4 instant-pay-cell">
								<p className="instant-pay-cell-title">Timecard/ invoice Criteria</p>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.InvoiceCriteria.Submitted]}
									</span>
									<p className="col-sm-11">Invoice submitted</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.InvoiceCriteria.AmountRatio]}
									</span>
									<p className="col-sm-11">Invoice within 10% of the estimate</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.InvoiceCriteria.AlreadyPaid]}
									</span>
									<p className="col-sm-11">Invoice has not been paid</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.TimeCardCriteria.Submitted]}
									</span>
									<p className="col-sm-11">Timecard submitted</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.TimeCardCriteria.HoursRatio]}
									</span>
									<p className="col-sm-11">Timecard within 10% of the estimate</p>
								</div>
								<div className="instant-pay-cell-content row">
									<span className="col-sm-1">
										{criteriaIconClassMap[reasons.TimeCardCriteria.AlreadyPaid]}
									</span>
									<p className="col-sm-11">Timecard has not been paid</p>
								</div>
							</div>
						</div>
					</div>
				</If>
			</div>
		);
	}
}

InstantPayAudit.propTypes = {
	user: PropTypes.object,
};

InstantPayAudit.defaultProps = {
	user: {},
};

export default InstantPayAudit;
